import { cn } from '@/lib/utils';
interface ReviewCardProps {
  className?: string;
  flag?: string;
  heading: string;
  name: string;
  rating: number;
  review: string;
}
const ReviewCard = ({
  flag,
  heading,
  name,
  rating,
  review,
  className
}: ReviewCardProps) => <div className={cn('flex min-w-72 flex-col gap-6 rounded-lg bg-white p-8 dark:bg-gray-950', className)} data-sentry-component="ReviewCard" data-sentry-source-file="index.tsx">
    <div className="flex flex-row">
      {Array.from({
      length: rating
    }, (_, index) => <svg aria-hidden="true" fill="none" height="14"
    // biome-ignore lint/suspicious/noArrayIndexKey: positional star, never reordered
    key={index} viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.59 0.411875L8.62642 4.4793L13.18 5.13154L9.885 8.29759L10.6628 12.7681L6.59 10.6574L2.51716 12.7681L3.295 8.29759L0 5.13154L4.55358 4.4793L6.59 0.411875Z" fill="#00B67A" />
        </svg>)}
    </div>
    <h3 className="font-sans font-semibold text-gray-950 text-lg dark:text-white">
      {heading}
    </h3>
    <p className="flex-1 font-sans leading-7">{review}</p>
    <div className="flex items-center gap-2">
      {flag ? <span className="mt-1">{flag}</span> : null}
      <span className="font-semibold dark:text-gray-300">{name}</span>
    </div>
  </div>;
export default ReviewCard;